import Image from 'next/image';
import type { ComponentProps } from 'react';
import { cn } from '@/lib/utils';

interface LogoPhiProps extends Omit<ComponentProps<'div'>, 'children'> {
  /** Alto en px. El ancho escala proporcional (logo es cuadrado). */
  size?: number;
  /** `noir` = Φ negro sobre fondo claro. `gold` = Φ dorado sobre fondo oscuro. */
  tone?: 'noir' | 'gold';
  label?: string;
}

/**
 * LogoPhi — símbolo Φ real de NQORO.
 * Asset: /public/brand/logo-phi.png (original entregado por Naye).
 *
 * IMPORTANTE: este NO es un SVG recreado. Es el logo oficial.
 * Mantener intacto: typography, trazo vertical, proporciones originales.
 */
export function LogoPhi({
  size = 32,
  tone = 'noir',
  label = 'NQORO · Φ',
  className,
  ...props
}: LogoPhiProps) {
  const src = tone === 'gold' ? '/brand/logo-phi-gold.png' : '/brand/logo-phi.png';
  return (
    <div
      aria-label={label}
      role="img"
      className={cn('relative inline-block shrink-0', className)}
      style={{ width: size, height: size }}
      {...props}
    >
      <Image
        src={src}
        alt=""
        fill
        sizes={`${size}px`}
        priority={size >= 48}
        className="object-contain"
      />
    </div>
  );
}
